var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _vm.reservation.show || 1
                        ? _c(
                            "v-container",
                            { attrs: { fluid: "" } },
                            [
                              _vm.reservation.hotel
                                ? _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 d-md-none",
                                          attrs: { cols: "4" },
                                        },
                                        [_c("b", [_vm._v("Reference")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 d-md-none",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.reservation.reference)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [_c("b", [_vm._v("Property")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.reservation.hotel.hotel_name
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [_c("b", [_vm._v("Client")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.reservation.user.first_name
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.reservation.user.last_name
                                              )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [_c("b", [_vm._v("Status")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.statusName(
                                                _vm.reservation.status_key
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [_c("b", [_vm._v("Enquiry")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.dateFormatDDMYYYYDay(
                                                _vm.reservation
                                                  .last_action_update_date
                                              )
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.reservation
                                                  .last_action_update_time
                                              )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [_c("b", [_vm._v("Arriving")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "8" },
                                        },
                                        [_vm._v(_vm._s(_vm.arrivalDate))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [_c("b", [_vm._v("Leaving")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "8" },
                                        },
                                        [_vm._v(_vm._s(_vm.departureDate))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [_c("b", [_vm._v("Stay Length")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.reservation.stay_length)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [_c("b", [_vm._v("Total Guests")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.totalGuests(_vm.reservation)
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [_c("b", [_vm._v("Rooms Requested")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _c(
                                            "ul",
                                            _vm._l(
                                              _vm.reservation.units,
                                              function (unit) {
                                                return _c("li", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.roomRequested(unit)
                                                    )
                                                  ),
                                                ])
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [_c("b", [_vm._v("Arrival Time")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.reservation.estimated_arrival
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }